import React, { useState } from 'react';
import { Box, Typography, IconButton, styled, keyframes } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { BuyUserMultitap, BuyUserEnergyLimit, BuyUserRechargeSpeed } from '../../Apis';
import { setUserData } from '../../store/slices/userSlice';
import ThreeSectionLodder from '../ThreeSectionLodder';
import { useNavigate } from 'react-router-dom';
import { FunctionCommas } from '../../utils/commasFun';

function MultitapModal({ onClose, content,setTafficLight, nextCost, nextLevel,loadder,setSuccess,setResultPopUp,setModalLoadder,setOpenModal,setNotEnoughPoint,setPopUpMessage}) {
    const dispatch = useDispatch();
    const { userId } = useSelector((state) => state.user);
    const userData = useSelector((state) => state.user.userData);
    const accessToken = useSelector((state)=>state?.user?.accessToken);
    const currentPoint = useSelector((state) => state?.point?.currentPoint)
    const navigate = useNavigate();

    const handleBuy = async () => {
        if(content?.nextCost > currentPoint ){
            
            setNotEnoughPoint(true);
            setOpenModal(false);
              return;
        }

        if (content.type === 'multitap') {

           dispatch(BuyUserMultitap(userId,accessToken,navigate,setResultPopUp,setSuccess,setModalLoadder,setOpenModal,setPopUpMessage,setTafficLight));        
        } else if (content.type === 'energyLimit') {
           dispatch(BuyUserEnergyLimit(userId,accessToken,navigate,setResultPopUp,setSuccess,setModalLoadder,setOpenModal,setPopUpMessage,setTafficLight));
        } else if (content.type === 'rechargingSpeed') {
             dispatch(BuyUserRechargeSpeed(userId,accessToken,navigate,setResultPopUp,setSuccess,setModalLoadder,setOpenModal,setPopUpMessage,setTafficLight));
        }

    };


    const FadeContainer = styled(Box)`
    animation: fadeIn 0.5s ease-in-out;
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
   `;
   const slideUp = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;
const slideDown = keyframes`
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(100%);
    opacity: 0;
  }
`;
    return (

        <Box
            sx={{
                position: 'absolute',
                bottom: 0,
                left:0,
                right:0,
                background: '#1B1529FA',
                height: '393px',
                zIndex: 1000000,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '25px',
                animation: `${slideUp} 200ms ease-out forwards`,
                padding:"23px",
                borderRadius:"25px"
                
            }}
        >
          { !loadder ? 
          <>       
          <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    color: '#fff',
                }}
            >
                <CloseIcon />
            </IconButton>
            <img src={content.icon} alt="icon" width={160} height={160} />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    gap: '10px',
                }}
            >
                <Typography
                    component="p"
                    sx={{
                        fontFamily: 'Inter',
                        fontWeight: 800,
                        fontSize: '32px',
                        lineHeight: '38.4px',
                        color: '#fff',
                    }}
                >
                    {content.title}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Inter',
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: '17px',
                        color: '#fff',
                        textAlign: 'center',
                        paddingX: '15px',
                    }}
                >
                    {content.description1}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Inter',
                        fontWeight: 700,
                        fontSize: '14px',
                        lineHeight: '17px',
                        color: '#fff',
                        textAlign: 'center',
                        paddingX: '15px',
                    }}
                >
                    {content.description2}
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '6px',
                }}
            >
                <img src={content.coinIcon} alt="coin_icon" />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        component="p"
                        sx={{
                            fontFamily: 'Inter',
                            fontWeight: 700,
                            fontSize: '18px',
                            lineHeight: '21.78px',
                            color: '#fff',
                        }}
                    >
                        {FunctionCommas(content.nextCost)}
                    </Typography>
                    <Typography
                        component="p"
                        sx={{
                            fontFamily: 'Inter',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '14.52px',
                            color: '#fff',
                            marginLeft:"4px"
                        }}
                    >
                         / {content.nextLevel} level
                    </Typography>
                </div>
            </Box>
            <Box
                sx={{
                    width: '100%',
                }}
            >
                <button
                    style={{
                        width: '100%',
                        background: '#674EFF',
                        outline: 'None',
                        border: 'None',
                        padding: '16px',
                        borderRadius: '12px',
                    }}
                    onClick={handleBuy}
                >
                    <Typography
                        sx={{
                            fontFamily: 'Inter',
                            fontWeight: 800,
                            fontSize: '18px',
                            lineHeight: '23.4px',
                            color: '#fff',
                        }}
                    >
                        Get it!
                    </Typography>
                </button>
            </Box>
                    
          </> :<ThreeSectionLodder/>}
        </Box>
    );
}

export default MultitapModal;
